export default function CartItem({ item, price, onIncrease, onDecrease }) {
  const subtotal = price * item.quantity;

  return (
    <div
      style={{
        padding: "14px",
        border: "1px solid #e5e7eb",
        borderRadius: "16px",
        background: "#f9fafb",
        display: "flex",
        justifyContent: "space-between",
        gap: "12px",
        alignItems: "center",
        flexWrap: "wrap",
      }}
    >
      {/* Left: Item Info */}
      <div style={{ flex: 1, minWidth: 160 }}>
        <div style={{ fontWeight: 900, textTransform: "capitalize", fontSize: 15 }}>
          {item.name}
        </div>

        <div style={{ fontSize: 13, color: "#6b7280", marginTop: 3 }}>
          {item.category} • ₹{price} / unit
        </div>
      </div>

      {/* Middle: Quantity Controls */}
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 13, color: "#6b7280" }}>Qty</span>

        <button className="iconBtn" onClick={() => onDecrease(item)}>
          −
        </button>

        <div
          style={{
            width: 28,
            textAlign: "center",
            fontWeight: 900,
            fontSize: 15,
          }}
        >
          {item.quantity}
        </div>

        <button className="iconBtn" onClick={() => onIncrease(item)}>
          +
        </button>
      </div>

      {/* Right: Subtotal */}
      <div style={{ textAlign: "right", minWidth: 90 }}>
        <div style={{ fontSize: 12, color: "#6b7280" }}>Subtotal</div>
        <div style={{ fontWeight: 900, fontSize: 16 }}>₹{subtotal}</div>
      </div>
    </div>
  );
}
